module.exports = __webpack_public_path__ + "media/images/hubs-bg-89c36b52ec6612cb0951de3e3d93ac7c.jpg";